/**
 * CUSTOM CART JS - NutriHangar Theme (v4 - Spedizione Gratuita Condizionale)
 * Strategia: Nessun ordine minimo. Spedizione gratuita >= €28,00.
 */
(function () {

    // Configurazione (Merge)
    window.NH_CONFIG = Object.assign({
        threshold: 2800,
        shippingCost: 499
    }, window.NH_CONFIG || {});

    console.log('NH DEBUG CONFIG:', window.NH_CONFIG);

    const formatMoney = (cents) => '€' + (cents / 100).toFixed(2).replace('.', ',');
    const setText = (id, txt) => { const e = document.getElementById(id); if (e) e.textContent = txt; };
    const setHtml = (id, html) => { const e = document.getElementById(id); if (e) e.innerHTML = html; };

    // 1. CHECKOUT (Form POST Nativo) — Nessun blocco ordine minimo
    window.nhForceCheckout = function () {
        let code = localStorage.getItem('nh_saved_code') || '';
        const input = document.getElementById('NH_Discount_Input');
        if (input && input.value.trim()) code = input.value.trim();
        if (code) localStorage.setItem('nh_saved_code', code);

        const form = document.createElement('form');
        form.method = 'POST';
        form.action = '/cart';
        form.style.display = 'none';

        const i1 = document.createElement('input'); i1.type = 'hidden'; i1.name = 'checkout'; i1.value = 'true';
        form.appendChild(i1);

        if (code) {
            const i2 = document.createElement('input'); i2.type = 'hidden'; i2.name = 'discount'; i2.value = code;
            form.appendChild(i2);
        }

        document.body.appendChild(form);
        form.submit();
    };

    // 2. APPLICA SCONTO (UI Only)
    window.nhApplyDiscount = function () {
        const input = document.getElementById('NH_Discount_Input');
        const msg = document.getElementById('NH_Discount_Msg');
        if (!input) return;
        const code = input.value.trim();
        if (code) {
            localStorage.setItem('nh_saved_code', code);
            if (msg) { msg.style.display = 'block'; msg.innerHTML = `Codice <strong>${code}</strong> salvato.`; }
        } else {
            localStorage.removeItem('nh_saved_code');
            window.updateCartVisuals();
        }
    };

    // 3. AGGIORNAMENTO VISUALE
    window.updateCartVisuals = async () => {
        try {
            const CONFIG = window.NH_CONFIG;

            // PARALLEL FETCH: Cart JSON + Shipping Bar HTML (Dynamic Settings)
            const [resCart, resBar] = await Promise.all([
                fetch('/cart.js', { cache: 'no-store' }),
                fetch('/?section_id=helper-shipping-bar&_t=' + new Date().getTime())
            ]);

            const cart = await resCart.json();

            // 0. DOM UPDATE: Shipping Bar (Sync Settings & Server-Side State)
            try {
                const barHtml = await resBar.text();
                const parser = new DOMParser();
                const doc = parser.parseFromString(barHtml, 'text/html');
                const newBar = doc.getElementById('js-shipping-bar-container');
                const currentBar = document.getElementById('js-shipping-bar-container');
                if (newBar && currentBar) {
                    currentBar.outerHTML = newBar.outerHTML;
                }
            } catch (e) { console.error('NH Shipping Bar Update Error:', e); }

            // Dispatch Event per altri componenti (es. Sticky ATC)
            document.dispatchEvent(new CustomEvent('nh:cart-updated', { detail: { cart: cart } }));

            const totalItemsPrice = cart.original_total_price;
            const subtotal = cart.total_price;
            const count = cart.item_count;

            // ANIMAZIONE & HAPTICS (Solo se il count è aumentato)
            const prevCount = parseInt(localStorage.getItem('nh_prev_cart_count') || '0');
            if (count > prevCount) {
                if (window.nhHaptics) window.nhHaptics('success');

                // Anima icone carrello (Header e Mobile Navbar)
                document.querySelectorAll('[data-header-cart-count], .mbn-item[href*="cart"]').forEach(el => {
                    const icon = el.closest('.mbn-item') || el.closest('a');
                    if (icon) {
                        icon.classList.remove('nh-anim-bump');
                        void icon.offsetWidth;
                        icon.classList.add('nh-anim-bump');
                    }
                });
            }
            localStorage.setItem('nh_prev_cart_count', count);

            // FIX: Toggle Header Buttons (Checkout vs Close)
            const fullBtns = document.querySelectorAll('.js-cart-full-btn');
            const emptyBtns = document.querySelectorAll('.js-cart-empty-btn');

            if (count === 0) {
                fullBtns.forEach(el => el.style.setProperty('display', 'none', 'important'));
                emptyBtns.forEach(el => el.style.setProperty('display', 'flex', 'important'));

                const header = document.querySelector('.sidebar__header');
                if (header) header.style.setProperty('background', '#fff', 'important');

                const sidebar = document.getElementById('site-cart-sidebar');
                if (sidebar) sidebar.classList.add('cart-is-empty');

            } else {
                fullBtns.forEach(el => el.style.setProperty('display', 'flex', 'important'));
                emptyBtns.forEach(el => el.style.setProperty('display', 'none', 'important'));

                const header = document.querySelector('.sidebar__header');
                if (header) {
                    header.style.setProperty('background', '#fff', 'important');
                    header.style.backgroundColor = '#fff';
                }

                const sidebar = document.getElementById('site-cart-sidebar');
                if (sidebar) sidebar.classList.remove('cart-is-empty');
            }

            // A. LOGICA SPEDIZIONE GRATUITA (Soglia €28,00 = 2800 centesimi)
            const FREE_SHIPPING_THRESHOLD = CONFIG.threshold;
            let shippingCost = 0;
            let isFreeShipping = false;
            let percent = 0;
            let remaining = 0;

            // DYNAMIC CONFIG (From DOM Attribute injected by Liquid)
            const shippingContainer = document.getElementById('js-shipping-bar-container');
            const isVip = shippingContainer ? shippingContainer.hasAttribute('data-vip') : false;

            // Override Config from DOM (Live Theme Editor Support)
            if (shippingContainer) {
                if (shippingContainer.dataset.threshold) {
                    CONFIG.threshold = parseInt(shippingContainer.dataset.threshold);
                }
                if (shippingContainer.dataset.shippingCost) {
                    CONFIG.shippingCost = parseInt(shippingContainer.dataset.shippingCost);
                }
            }

            if (count > 0) {
                if (isVip) {
                    isFreeShipping = true;
                    remaining = 0;
                } else {
                    isFreeShipping = (subtotal >= FREE_SHIPPING_THRESHOLD);
                    remaining = FREE_SHIPPING_THRESHOLD - subtotal;
                }

                shippingCost = isFreeShipping ? 0 : CONFIG.shippingCost;
                percent = isFreeShipping ? 100 : Math.min((subtotal / FREE_SHIPPING_THRESHOLD) * 100, 100);
            }

            // B. AGGIORNA BARRA PROGRESSO SPEDIZIONE GRATUITA
            const statusBar = document.getElementById('js-shipping-bar-container');
            const fill = document.getElementById('js-progress-fill');
            const msgEmpty = document.getElementById('js-order-empty');
            const msgReady = document.getElementById('js-shipping-ready');
            const msgPending = document.getElementById('js-shipping-pending');
            const remainingSpan = document.getElementById('js-remaining');

            // Aggiorna data attribute (per compatibilità)
            if (statusBar) {
                statusBar.dataset.freeShipping = isFreeShipping ? 'true' : 'false';
            }

            // Aggiorna barra progresso
            if (fill) {
                fill.style.width = percent + '%';
                if (isFreeShipping) {
                    fill.classList.add('osb-fill--ready');
                } else {
                    fill.classList.remove('osb-fill--ready');
                }
            }

            // Aggiorna messaggi
            if (count === 0) {
                if (msgEmpty) msgEmpty.style.display = 'block';
                if (msgReady) msgReady.style.display = 'none';
                if (msgPending) msgPending.style.display = 'none';
            } else if (isFreeShipping) {
                if (msgEmpty) msgEmpty.style.display = 'none';
                if (msgReady) msgReady.style.display = 'block';
                if (msgPending) msgPending.style.display = 'none';
            } else {
                if (msgEmpty) msgEmpty.style.display = 'none';
                if (msgReady) msgReady.style.display = 'none';
                if (msgPending) msgPending.style.display = 'block';
                if (remainingSpan) remainingSpan.textContent = formatMoney(remaining);
            }

            // HEADER ANIMATION STATUS (Spedizione Gratuita)
            const headerStatus = document.getElementById('nh-header-shipping-status');
            if (headerStatus) {
                if (count === 0) {
                    headerStatus.style.display = 'none';
                } else {
                    headerStatus.style.display = 'flex';
                }

                const track = headerStatus.querySelector('.nh-track-line');

                if (isFreeShipping) {
                    headerStatus.innerHTML = `
                        <div style="display: flex; align-items: center; justify-content: center; gap: 8px; width: 100%;">
                            <span style="font-size: 24px; line-height: 1;" class="nh-mobile-ready-icon">📦</span>
                            <div style="display: flex; flex-direction: column; justify-content: center; line-height: 1.1;">
                                <span class="nh-mobile-ready-title" style="display:block; font-weight:900; font-size:11px; color:#051b35; text-shadow:none; letter-spacing: 0.5px;">SPEDIZIONE GRATUITA!</span>
                                <span class="nh-mobile-ready-sub" style="display:block; font-size:9px; color:#051b35; font-weight:700; text-shadow:none;">+ OMAGGIO INCLUSO</span>
                            </div>
                        </div>
                    `;
                    headerStatus.classList.add('is-ready');
                    if (track) track.style.opacity = '0';
                } else {
                    headerStatus.innerHTML = `<span style="display:block; color:#555; font-size:12px; font-weight:700;">MANCANO ${formatMoney(remaining)} per la spedizione gratuita</span>`;
                    headerStatus.classList.remove('is-ready');
                    if (track) track.style.opacity = '1';
                }
            }

            // PULSANTE CHECKOUT: Sempre attivo se ci sono prodotti
            const checkoutBtns = document.querySelectorAll('.js-cart-full-btn button, .js-checkout-btn');
            checkoutBtns.forEach(btn => {
                if (count === 0) {
                    btn.disabled = true;
                    btn.style.opacity = '0.5';
                    btn.style.cursor = 'not-allowed';
                } else {
                    btn.disabled = false;
                    btn.style.opacity = '1';
                    btn.style.cursor = 'pointer';
                }
            });

            // C. AGGIORNA FOOTER & TOTALI
            setText('js-footer-subtotal', formatMoney(totalItemsPrice));
            const elShipping = document.getElementById('js-footer-shipping');
            if (elShipping) {
                if (count === 0) {
                    elShipping.innerHTML = '<span style="color:#666;">-</span>';
                } else if (isFreeShipping) {
                    elShipping.innerHTML = '<span style="color:#28a745;">Gratis</span>';
                } else {
                    elShipping.textContent = formatMoney(shippingCost);
                }
            }

            setText('js-footer-grand-total', formatMoney(subtotal + shippingCost));

            // Toggle riga sconto
            const discountRow = document.getElementById('js-footer-discounts-container');
            if (discountRow) {
                if (cart.total_discount > 0) {
                    discountRow.style.display = 'flex';
                    setText('js-footer-discounts-amount', '-' + formatMoney(cart.total_discount));
                } else {
                    discountRow.style.display = 'none';
                }
            }

            // F. AGGIORNA UPSELL DINAMICO (Anti-Cache & Force Refresh)
            try {
                const upsellRes = await fetch('/?section_id=helper-upsell&_t=' + new Date().getTime());
                const upsellHtml = await upsellRes.text();

                const parser = new DOMParser();
                const doc = parser.parseFromString(upsellHtml, 'text/html');
                const newUpsell = doc.getElementById('js-cart-upsell-wrapper');
                const currentUpsell = document.getElementById('js-cart-upsell-wrapper');

                if (newUpsell && currentUpsell) {
                    currentUpsell.outerHTML = newUpsell.outerHTML;
                } else if (newUpsell && !currentUpsell) {
                    const shippingBar = document.getElementById('js-shipping-bar-container');
                    if (shippingBar) {
                        shippingBar.appendChild(newUpsell);
                    }
                }
            } catch (upsellErr) {
                console.error('Error updating upsell:', upsellErr);
            }

            // D. HEADER BUTTON (Totale)
            const headerTotal = document.getElementById('header-cart-total-display');
            if (headerTotal) {
                headerTotal.textContent = (count === 0) ? formatMoney(0) : formatMoney(subtotal);
                headerTotal.style.display = 'inline-block';
            }
            document.querySelectorAll('[data-header-cart-count], .mbn-cart-count, [data-cart-count]').forEach(el => {
                el.textContent = count;
            });

            // E. WIDGET SALVA CARRELLO: Funzionalità rimossa su richiesta.

        } catch (e) { console.error('NH Cart Main Error:', e); }
    };

    // 4. LISTENERS (Fetch & XHR Intercept - SAFE MODE)
    const originalFetch = window.fetch;
    window.fetch = function () {
        let url = '';
        try {
            url = (typeof arguments[0] === 'string') ? arguments[0] : (arguments[0].url || '');
        } catch (e) { }

        const fetchPromise = originalFetch.apply(this, arguments);

        // Intercept ONLY internal cart calls
        if (url && typeof url === 'string' && /\/cart\/(add|change|update|clear)(?:\.js)?(?:[?#]|$)/.test(url) && !url.includes('http')) {
            fetchPromise.then((response) => {
                if (response.ok) {
                    if (window._nhUpdateTimer) clearTimeout(window._nhUpdateTimer);
                    window._nhUpdateTimer = setTimeout(window.updateCartVisuals, 300);
                }
            }).catch(e => {
                // Silent catch
            });
        }

        return fetchPromise;
    };

    // Supporto Eventi Custom
    document.addEventListener('DOMContentLoaded', () => { window.updateCartVisuals(); });
    document.addEventListener('cart-updated', () => window.updateCartVisuals());

})();